<template>
  <Breadcrumb></Breadcrumb>
  <LeaseAgreementForm :leaseAgreement="leaseAgreement" :title="$gettext('Nouveau bail de location')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useLeaseAgreementStore } from "@/stores/leaseAgreement";
import { useRouter, useRoute } from "vue-router";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import LeaseAgreementForm from "@/components/lease-agreements/LeaseAgreementForm.vue";

const router = useRouter();
const route = useRoute();
const rentalListingAgreementId = route.query.rentalListingAgreementId;
const propertyId = route.query.propertyId;
const leaseAgreementStore = useLeaseAgreementStore();
const leaseAgreement = leaseAgreementStore.empty;

const onSubmit = (payload, actions) => {
  leaseAgreementStore.save(payload, rentalListingAgreementId, propertyId, () => {
    router.push({ name: "rental-listing-agreement", params: { id: rentalListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

</script>
